import { render } from "./FieldsSpiritual.vue?vue&type=template&id=723298e0"
import script from "./FieldsSpiritual.vue?vue&type=script&lang=js"
export * from "./FieldsSpiritual.vue?vue&type=script&lang=js"
script.render = render

export default script